var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-snackbar',_vm._g(_vm._b({attrs:{"timeout":_vm.timeout,"value":_vm.value,"content-class":"black--text"},on:{"input":_vm.input}},'v-snackbar',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }